import Button1 from "./blocks/Button1/Button1";
import Button2 from "./blocks/Button2/Button2";
import Button3 from "./blocks/Button3/Button3";
import Button4 from "./blocks/Button4/Button4";
import Button5 from "./blocks/Button5/Button5";
import Button6 from "./blocks/Button6/Button6";
import ButtonProps from "./ButtonProps.interface";
import getButtonClasses from "./helpers/getButtonClasses";
import getButtonContentType from "./helpers/getButtonContentType";
import getButtonStyles from "./helpers/getButtonStyles";
import useCompliance from "./hooks/useCompliance";
import useUnbounce from "./hooks/useUnbounce";
import useWebi from "./hooks/useWebi";
import useFixrOverlay from "layout/Header/blocks/Header2/components/FixrOverlay/hooks/useFixrOverlay";

import { useSelector } from "react-redux";
import combineClasses from "helpers/combine-classes";
import getRelativeUrl from "helpers/getRelativeUrl";
import React, { Fragment, FunctionComponent } from "react";

const BUTTON_TYPES: { [key: string]: any } = {
    "blockButton1": Button1,
    "blockButton2": Button2,
    "blockButton3": Button3,
    "blockButton4": Button4,
    "blockButton5": Button5,
    "blockButton6": Button6
};

const Button: FunctionComponent<ButtonProps> = (props): JSX.Element => {
    const settings = useSelector(state => state.settings.content);
    const [webiId, webiClasses, webiTitle] = useWebi(props);
    const [onComplianceClick] = useCompliance(props, settings);
    const [onUnbounceClick] = useUnbounce();

    const themeContentType = getButtonContentType(settings?.theme, props.variant);
    const themeButtonStyles = getButtonStyles(settings?.theme, props.variant);
    const themeButtonClasses = getButtonClasses(settings?.theme, props.variant, props.width);

    const DynamicButton = BUTTON_TYPES[props.contentType ?? themeContentType ?? "blockButton3"];

    const { toggleFixrOverlay } = useFixrOverlay(props as any);

    // Checking if link is Media Picker and not a Content Picker that is mapped.
    const link = typeof (props.to?._contentType) !== "undefined" ? getRelativeUrl(props.to?._url) : props.to;

    const whatButtonClick = () => {
        if ((props._contentType === "webiButton" || props._contentType === "webiAnchor")) {
            return undefined;
        }
        else if ((props._contentType === "complianceButton" || props._contentType === "complianceAnchor") && typeof (onComplianceClick) !== "undefined") {
            return onComplianceClick;
        }
        else if (props._contentType === "fixrButton") {
            return toggleFixrOverlay;
        }
        else if (props._contentType === "unbounceButton") {
            return onUnbounceClick;
        }
        else if (props._contentType === "simpleFormSubmitButton") {
            return true;
        }
        else if (typeof (props.onClick) !== "undefined") {
            return props.onClick;
        }

        return undefined;
    };



    return (
        <Fragment>
            {DynamicButton ? (
                <DynamicButton style={{ ...themeButtonStyles, ...props.style }} id={webiId} className={combineClasses(props.className, ...themeButtonClasses, ...webiClasses)} to={link} title={webiTitle} onClick={whatButtonClick()}>
                    {props.children}
                </DynamicButton>
            ) : null}
        </Fragment>
    );
};

export default Button;